(() => {
 const gate=document.querySelector('[data-aag]');
 if(!gate)return;
 const code=(gate.dataset.accessCode||'').trim().toLowerCase();
 const key='aamplified-drop-access';
 const legacy='aa_gate_pass';
 const valid=()=>{try {
  if(code&&localStorage.getItem(key)==='granted:'+code)return true;
  const old=JSON.parse(localStorage.getItem(legacy)||'null');
  return !!(code&&old&&String(old.c||'').trim().toLowerCase()===code);
 }catch(e){return false;}};
 const unlock=()=>{gate.remove();document.documentElement.classList.add('aag-unlocked');};
 if(valid()){unlock();return;}
 const signup=gate.querySelector('#AaxAccessForm');
 signup?.addEventListener('submit',async e=>{
  e.preventDefault();
  if(signup.dataset.submitting==='true')return;
  const status=gate.querySelector('[data-aag-signup-status]');
  const email=signup.querySelector('input[type="email"]').value.trim();
  const rawPhone=signup.querySelector('#AagPhone')?.value.trim()||'';
  const consent=signup.querySelector('#AagSmsConsent')?.checked===true;
  const digits=rawPhone.replace(/\D/g,'');
  const phone=digits.length===10?'+1'+digits:digits.length===11&&digits[0]==='1'?'+'+digits:'';
  if(consent&&!phone){status.textContent='Enter a valid US mobile number, or leave text signup unchecked.';return;}
  signup.dataset.submitting='true';
  const button=signup.querySelector('button[type="submit"]');button.disabled=true;
  status.textContent='Sending your access request...';
  async function subscribe(list,attributes){
   const response=await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=VwjhSh',{
    method:'POST',headers:{'Content-Type':'application/vnd.api+json',revision:'2026-07-15'},
    body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'AAMPLIFIED Member Gate',profile:{data:{type:'profile',attributes}}},relationships:{list:{data:{type:'list',id:list}}}}})
   });
   if(!response.ok)throw new Error('subscription_failed');
  }
  try{
   await subscribe('RJTSN4',{email,subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}});
   status.textContent='Check your inbox for your access code. If you already joined, use the code in your original access email.';
   if(consent){
    try{
     await subscribe('W62cXU',{email,phone_number:phone,subscriptions:{sms:{marketing:{consent:'SUBSCRIBED'}}}});
     status.textContent+=' Check your texts and confirm your optional SMS signup.';
    }catch(error){status.textContent+=' Your text signup did not go through. You can retry; your email request was received.';}
   }
  }catch(error){status.textContent='We could not send your access request. Please try again. Your access has not been unlocked.';}
  finally{signup.dataset.submitting='false';button.disabled=false;}
 });
 const toggle=gate.querySelector('[data-aag-code-toggle]');
 const panel=gate.querySelector('[data-aag-code-panel]');
 toggle?.addEventListener('click',()=>{
  panel.hidden=!panel.hidden;
  toggle.setAttribute('aria-expanded',String(!panel.hidden));
  if(!panel.hidden)panel.querySelector('input')?.focus();
 });
 panel?.addEventListener('submit',e=>{
  e.preventDefault();
  const entered=(panel.querySelector('input').value||'').trim().toLowerCase();
  if(code&&entered===code){
   try{localStorage.setItem(key,'granted:'+code);}catch(e){}
   unlock();
  }else{
   const err=gate.querySelector('[data-aag-code-error]');
   if(err)err.hidden=false;
  }
 });
})();
